import React from 'react';
import { motion } from 'framer-motion';
export function BonusSection() {
  const bonuses = [{
    id: 1,
    name: 'Psicotécnico PRO',
    description: 'Entrená con ejercicios pensados para prepararte para una de las pruebas que más aspirantes subestiman.',
    value: '$8.990'
  }, {
    id: 2,
    name: 'Primeros Auxilios',
    description: 'Accedé a una guía práctica con contenidos esenciales que pueden formar parte de la preparación general del aspirante.',
    value: '$6.990'
  }, {
    id: 3,
    name: 'Simulacros por Fuerza',
    description: 'Ponete a prueba con simulaciones de examen para llegar más preparado y con menos incertidumbre.',
    value: '$9.990'
  }, {
    id: 4,
    name: 'Guía de Entrevista Final',
    description: 'Descubrí cómo prepararte para una de las etapas más decisivas del proceso.',
    value: '$7.990'
  }, {
    id: 5,
    name: 'Plan de Entrenamiento 8 Semanas',
    description: 'Un plan pensado para ayudarte a trabajar tu preparación física de forma progresiva.',
    value: '$8.990'
  }];
  const formatNumber = (num: number) => num.toString().padStart(2, '0');
  return <section className="py-5 px-4 sm:px-6 lg:px-8 bg-gradient-to-b from-gray-900 to-black border-t border-gray-800" data-id="element-16">
      <div className="max-w-5xl mx-auto" data-id="element-17">
        <div className="text-center mb-4" data-id="element-18">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-white mb-2" data-id="element-19">
            Y además hoy te llevás estos bonos incluidos
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 mb-4" data-id="element-20">
          {bonuses.map((bonus, index) => <motion.div key={bonus.id} initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.08
        }} className={index === 4 ? 'sm:col-span-2 lg:col-span-1 lg:col-start-2' : ''} data-id="element-21">
              <div className="bg-black border border-blue-500/20 rounded-xl p-4 h-full relative overflow-hidden flex flex-col" data-id="element-22">
                <span className="absolute top-2 right-3 text-6xl font-black text-green-500/20 select-none pointer-events-none" data-id="element-23">
                  {formatNumber(bonus.id)}
                </span>
                <div className="relative z-10 flex flex-col flex-1" data-id="element-24">
                  <span className="text-green-500 text-xs font-bold uppercase tracking-wider mb-1" data-id="element-25">
                    BONO #{formatNumber(bonus.id)}
                  </span>
                  <h3 className="text-lg font-bold text-white mb-1" data-id="element-26">
                    {bonus.name}
                  </h3>
                  <p className="text-sm text-gray-400 mb-3 flex-1" data-id="element-27">
                    {bonus.description}
                  </p>
                  <div className="flex items-center justify-between mt-auto" data-id="element-28">
                    <span className="text-gray-500 line-through text-sm" data-id="element-29">
                      Valor {bonus.value}
                    </span>
                    <span className="bg-green-500 text-black text-xs font-bold px-3 py-1 rounded uppercase tracking-wider" data-id="element-30">
                      GRATIS
                    </span>
                  </div>
                </div>
              </div>
            </motion.div>)}
        </div>

        <div className="text-center bg-blue-500/5 border border-blue-500/30 rounded-xl p-4" data-id="element-31">
          <p className="text-lg md:text-xl text-gray-400 line-through mb-1 font-medium" data-id="element-32">
            Valor total de los bonos: $42.950
          </p>
          <p className="text-2xl md:text-3xl font-bold text-blue-400 uppercase tracking-wider" data-id="element-33">
            HOY INCLUIDOS GRATIS
          </p>
        </div>
      </div>
    </section>;
}